import { Height } from "@mui/icons-material";

export const uploadDetailsStyles = {
  root: {
    height: 'calc(100vh - 148px)',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    padding: '16px',
    pb: 0,
    overflowY: 'auto',
    gap: '16px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    flex: 1,
    gap: 0,
    pb: '30px',
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  stepText: {
    color: 'rgba(0, 0, 0, 0.38)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "266%", 
    letterSpacing: "1px",
    textTransform: "uppercase",
    height: '32px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  titleRow: {
    display: 'flex',
    gap: 0.75,
    alignItems: 'center',
    height: '32px',
  },
  titleText: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: '16px',
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "150%", 
    letterSpacing: "0.15px",
  },
  requiredMark: {
    fontFamily: "Noto Sans",
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '32px',
    color: '#c62828',
  },
  subtitle: {
    color: 'rgba(0, 0, 0, 0.60)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: '14px',
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "143%", 
    letterSpacing: "0.17px",
    display: 'flex',
    height: '40px',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  uploadArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
    maxWidth: 900,
    aspectRatio: '1.6 / 1',
    padding: 0,
    backgroundColor: '#FFFFFF',
    gap: 0,
    alignSelf: 'center',
    borderRadius: 'var(--Corner-s, 8px)',
    border: '1px solid var(--divider, rgba(0, 0, 0, 0.12))',
    overflow: 'hidden',
  },
  previewSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 0,
    width: '100%',
    height: '100%',
    flex: 1,
  },
  previewCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#ECECF0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
  },
  previewIcon: {
    color: '#76768A',
    fontSize: 44,
  },
  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover', 
  },
  uploadedImageContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    flex: 1,
    borderRadius: 'inherit',
    overflow: 'hidden',
    margin: 0,
  },
  uploadedPanImage: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  deleteImageButton: {
    position: 'absolute',
    bottom: 16,
    right: 16,
    bgcolor: 'white',
    boxShadow: '1px 2px 6px 0px rgba(0,0,0,0.16)',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: '50%',
    '&:hover': {
      bgcolor: '#f5f5f5',
    },
  },
  editImageButton: {
    display: 'inline-flex',
    padding: '4px 12px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '80px',
    background: 'rgba(0, 0, 0, 0.56)',
    boxShadow: '1px 2px 6px 0 rgba(0, 0, 0, 0.16)',
    position: 'absolute',
    bottom: 12,
    right: 12,
  },
  editButtonText: {
    color: 'var(--common-white_states-main, #FFF)',
    fontFamily: "Noto Sans",
    fontSize: '13px',
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "22px",
    letterSpacing: "0.46px",
  },
  inlineLoaderOverlay: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    mt: 1.5,
    width: '100%',
    borderRadius: '12px',
    padding: '12px 16px',
  },
  inlineLoaderIconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#16A34A',
  },
  inlineLoaderStatusText: {
    color: '#166534',
    fontFamily: "Noto Sans",
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.17px',
  },
  instructionText: {
    fontFamily: 'Noto Sans, sans-serif',
    color: '#717182',
    textAlign: 'center',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.15px',
  },
  errorRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    mt: 1,
    px: 1,
    width: '100%',
    maxWidth: 360,
  },
  errorIconWrap: {
    mt: '2px',
    display: 'flex',
    flexShrink: 0,
  },
  errorText: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 13,
    color: '#B71B1C',
    letterSpacing: '0.17px',
    lineHeight: 1.43,
    textAlign: 'left',
  },
  actionRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'stretch',
    gap: { xs: 1.5, sm: 3 },
    maxWidth: 900,
    alignSelf: 'center',
  },
  actionItem: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    flex: '1 0 0',
    alignSelf: 'stretch',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#BBD8E4',
      backgroundColor: '#FFFFFF',
    },
    borderRadius: '8px', 
  },
  cameraActionItem: {
    border: '2px dashed #B2EAF2',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #E0F7FA 100%)',
  },
  galleryActionItem: {
    border: '2px dashed  #DDCEDB',
    background: 'linear-gradient(180deg, #FFFFFF 0%, #F6EAF2 100%)',
  },
  actionIconCircle: {
    display: 'flex',
    width: 48,
    height: 48,
    padding: '10.537px 9.951px 9.366px 9.951px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cameraActionIconCircle: {
    borderRadius: '234.146px',
    background: 'var(--common-white_states-main, #FFF)',
  },
  galleryActionIconCircle: {
   borderRadius: '234.146px',
    background: 'var(--common-white_states-main, #FFF)',
  },
  cameraIcon: {
    color: '#0E98AF',
    width: 40,
    height: 40,
  },
  galleryIcon: {
    color: '#6F5674',
    width: 40,
    height: 40,
  },
  actionTitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "175%", 
    letterSpacing: "0.15px",
  },
  actionSubtitle: {
    color: 'rgba(0, 0, 0, 0.60)',
    textAlign: 'center',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Noto Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: '143%',
    letterSpacing: '0.17px',
  },
  hiddenFileInput: {
    position: 'absolute' as const,
    width: 0,
    height: 0,
    opacity: 0,
    overflow: 'hidden',
    pointerEvents: 'none' as const,
  },
  resultSection: {
    width: '100%',
    maxWidth: 460,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    pb: 2,
  },
  statusText: (isSuccess: boolean) => ({
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.43,
    color: isSuccess ? '#007d00' : '#b71b1c',
  }),
  tds10Notice: {
    borderRadius: '8px',
    padding: '12px',
    backgroundColor: '#e6f4ea',
  },
  tds10Text: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.43,
    color: '#1f2937',
  },
  tds20Notice: {
    borderRadius: '8px',
    padding: '12px',
    backgroundColor: '#fff4e5',
  },
  tds20Text: {
    fontFamily: "'Noto Sans', sans-serif",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.43,
    color: '#1f2937',
  },
  snackbar: {
    bottom: {
      xs: 90,
      sm: 0,
    },
    '& .MuiSnackbarContent-root': {
      display: 'flex',
      width: '320px',
      padding: '6px 16px',
      alignItems: 'center',
      gap: '16px',
    },
    '& .MuiSnackbarContent-message': {
      padding: 0,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      flex: 1,
      marginRight: '20px',
      color: 'var(--common-white_states-main, #FFF)',
      fontFeatureSettings: "'liga' off, 'clig' off",
      fontFamily: "Noto Sans",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "143%", 
      letterSpacing: "0.17px",
    },
    '& .MuiSnackbarContent-action': {
      marginRight: 0,
      padding: 0,
      flexShrink: 0,
    },
  },
  snackbarActionButton: {
    display: 'flex',
    padding: '4px 5px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 'var(--Corner-s, 8px)',
    color: 'var(--primary-contrastText, #FFF)',
    fontFamily: "Noto Sans",
    fontSize: 'var(--font-size-08125-rem, 13px)',
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: '22px', 
    letterSpacing: '0.46px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus-visible': {
      outline: '2px solid #ffffff',
      outlineOffset: '3px',
      borderRadius: '2px',
    },
  },
};
